import { jsxs, jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import "@volue/stitches-core";
import EzGlobalStyles from "../EzGlobalStyles/EzGlobalStyles.es.js";
import stitches from "../theme.config.es.js";
const EzAppLayoutContext = createContext("full");
const style = stitches.css({
  variants: {
    layout: {
      full: {},
      centered: {
        margin: "0 auto",
        maxWidth: "$app-layout-max-width"
      }
    }
  }
});
const frame = stitches.css({
  width: "$full",
  minHeight: "100vh",
  display: "flex",
  position: "relative",
  flexWrap: "nowrap",
  flexDirection: "column"
});
const EzAppLayout = ({ children, layout }) => {
  return /* @__PURE__ */ jsxs("div", { className: frame(), children: [
    /* @__PURE__ */ jsx(EzGlobalStyles, {}),
    /* @__PURE__ */ jsx(EzAppLayoutContext.Provider, { value: layout, children })
  ] });
};
EzAppLayout.displayName = "EzAppLayout";
const MaxWidth = ({ children }) => {
  const layout = useContext(EzAppLayoutContext);
  return /* @__PURE__ */ jsx("div", { className: style({ layout }), children });
};
export {
  EzAppLayoutContext,
  MaxWidth,
  EzAppLayout as default
};
//# sourceMappingURL=EzAppLayout.es.js.map
